// src/resources/dashboards/Painel360/InsightsSection.tsx
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { motion } from 'framer-motion';
import { COLORS, EASE_OUT, ErrorCard, SectionHeader, SkeletonCard, cardSx, openInNewTab } from './shared';
import { InsightsData, InsightSeverity, SectionState } from './types';

const SEVERITY_COLOR: Record<InsightSeverity, string> = {
  danger: COLORS.danger, warning: COLORS.warning, success: COLORS.success, info: COLORS.blue,
};

const InsightsSection = ({ state }: { state: SectionState<InsightsData> }) => {
  if (state.loading) return <SkeletonCard height={150} />;
  if (state.error) return <ErrorCard onRetry={state.refetch} height={150} />;
  const bullets = state.data?.bullets ?? [];
  if (!bullets.length) return null; // sem insight = seção some (padrão InsightsBar)

  return (
    <Box>
      <SectionHeader
        icon={<LightbulbIcon sx={{ fontSize: 18 }} />}
        gradient={`linear-gradient(135deg, ${COLORS.brand2}, ${COLORS.brand})`}
        title="O que merece sua atenção"
        subtitle="Insights gerados automaticamente a partir dos seus dados"
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {bullets.map((b, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.06, duration: 0.25, ease: EASE_OUT }}
          >
            <Box sx={{ ...cardSx, p: 1.75, display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ width: 10, height: 10, borderRadius: '50%', flex: 'none', bgcolor: SEVERITY_COLOR[b.severity] }} />
              <Typography sx={{ fontSize: 13.5, color: COLORS.ink, flex: 1 }}>{b.text}</Typography>
              {b.ctaLabel && b.ctaLink && (
                <Button size="small" sx={{ flex: 'none', fontWeight: 700, fontSize: 12, color: COLORS.brand, whiteSpace: 'nowrap' }}
                  onClick={() => openInNewTab(b.ctaLink!)}>
                  {b.ctaLabel} →
                </Button>
              )}
            </Box>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default InsightsSection;
